import React from 'react'
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import PrivacyTipRoundedIcon from '@mui/icons-material/PrivacyTipRounded';
import SupportRoundedIcon from '@mui/icons-material/SupportRounded';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
// import 'react-quill/dist/quill.snow.css';
import { Link } from 'react-router-dom';
import { useLocation} from 'react-router-dom';
// import { useNavigate } from 'react-router-dom';

// const DrawerHeader = styled('div')(({ theme }) => ({
//     display: 'flex',
//     alignItems: 'center',
//     padding: theme.spacing(0, 1),
//     // necessary for content to be below app bar
//     ...theme.mixins.toolbar,
//     justifyContent: 'flex-end',
// }));

// const themeOptions = {
//     palette: {
//       type: 'light',
//       primary: {
//         main: 'rgb(255, 53, 3)',
//       },
//       secondary: {
//         main: 'rgb(0, 0, 0)',
//       },
//     },
//   };


const sidebar_icon = [{'id':3,'icon':SupportRoundedIcon}, {'id':4,'icon':PrivacyTipRoundedIcon}, {'id':5, 'icon': SupportAgentOutlinedIcon},{'id':6,'icon':HandshakeOutlinedIcon},{'icon':DeleteOutlineOutlinedIcon}]; 
export default function Privacy() {
    // const history = useHistory();
    // const theme = useTheme();
    // const navigate = useNavigate();
    const location = useLocation();
    const { username } = location.state || '';
    const {loginStatus} = location.state || false;
    return (
        <>
            {/* <>
                <List>
                    {[{ text: 'Terms & Conditions', url: 'http://52.45.126.167/myplayer/terms_condition.html' },
                    { text: 'Privacy Policy', url: 'http://52.45.126.167/myplayer/privacy_policy.html' },
                    { text: 'Help & Support', url: 'http://52.45.126.167/myplayer/help_and_support.html' }].map((item, index) => (
                        <ListItem key={item.text} disablePadding>
                            <ListItemButton onClick={() => window.open(item.url, '_blank')}>
                                <ListItemIcon>
                                    {React.createElement(help_icon[index])}
                                </ListItemIcon>
                                <ListItemText primary={item.text} />
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </> */}

            <>
                <List>

                    <ListItem key="Terms & Conditions" disablePadding>
                            <ListItemButton component={Link} to="/cms/editorwindow" state={{id:sidebar_icon[0].id, username: username,loginStatus:loginStatus}}>
                                <ListItemIcon>
                                    {React.createElement(sidebar_icon[0].icon)}
                                </ListItemIcon>
                                <ListItemText primary="Terms & Conditions" />
                            </ListItemButton>
                    </ListItem>

                    <ListItem key="Privacy & Policy" disablePadding>
                        <ListItemButton component={Link} to="/cms/editorwindow" state= {{ id: sidebar_icon[1].id, username: username, loginStatus: loginStatus }}>
                            <ListItemIcon>
                                {React.createElement(sidebar_icon[1].icon)}
                            </ListItemIcon>
                            <ListItemText primary="Privacy & Policy" />
                        </ListItemButton>
                    </ListItem>

                    <ListItem key="Help & Support" disablePadding>
                        <ListItemButton component={Link} to="/cms/editorwindow" state={{ id: sidebar_icon[2].id, username: username, loginStatus: loginStatus }}>
                            <ListItemIcon>
                                {React.createElement(sidebar_icon[2].icon)}
                            </ListItemIcon>
                            <ListItemText primary="Help & Support" />
                        </ListItemButton>
                    </ListItem>

                    <ListItem key="Eula" disablePadding>
                        <ListItemButton component={Link} to="/cms/editorwindow" state={{ id: sidebar_icon[3].id, username: username, loginStatus: loginStatus }}>
                            <ListItemIcon>
                                {React.createElement(sidebar_icon[3].icon)}
                            </ListItemIcon>
                            <ListItemText primary="EULA" />
                        </ListItemButton>
                    </ListItem>

                    <ListItem key="Delete Account" disablePadding>
                        <ListItemButton component={Link} to="https://beeitech.com/deleteaccount.html">
                            <ListItemIcon>
                                {React.createElement(sidebar_icon[4].icon)}
                            </ListItemIcon>
                            <ListItemText primary="Delete Account"/>
                        </ListItemButton>
                    </ListItem>

                </List>
            </>

        </>
    )
}
